
<div class="tbl-txt"  [class.itemChosen]="item.chosen == true">
    <!-- {{item.text}} -->

    <table class="table-txt">
        <thead>
            <th *ngFor="let header of getTblHeaders()">{{header}}</th>
        </thead>
        <tbody>
            <tr class="tableRow" *ngFor="let data of getTbData()">
                <td class="tableData" *ngFor="let td of data">
                    {{td}}
                </td>
            </tr>

        </tbody>

    </table>
</div>